import { messaging, getToken, onMessage } from "./firebase-config";
import axios from "./axios";

const VAPID_KEY = "BK0cMB3f4MMO207B1RFmLxoqQOdK5sLNsjBE3aAHl7HJbGDYl7OoAuVIjv1AgYz3UC_4eFNkcI8p9u8EZBpLuHs";

/**
 * Register the Firebase messaging service worker
 * @returns {Promise<ServiceWorkerRegistration|null>}
 */
const registerServiceWorker = async () => {
  if (!("serviceWorker" in navigator)) {
    return null;
  }

  try {
    const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js", {
      scope: "/",
    });
    await navigator.serviceWorker.ready;
    return registration;
  } catch (error) {
    return null;
  }
};

/**
 * Request notification permission and get FCM token
 * @returns {Promise<string|null>} FCM token or null if permission denied
 */
export const requestFirebaseNotificationPermission = async () => {
  try {
    if (!("Notification" in window)) {
      return null;
    }

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      return null;
    }

    const swRegistration = await registerServiceWorker();
    if (!swRegistration) {
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: swRegistration,
    });

    return token;
  } catch (err) {
    return null;
  }
};

/**
 * Setup foreground message handler
 * @param {Function} onMessageCallback - Callback when message received in foreground
 * @returns {Function} Unsubscribe function
 */
export const setupForegroundMessageHandler = onMessageCallback => {
  if (!messaging) {
    return () => {};
  }

  return onMessage(messaging, payload => {
    const notification = {
      id: payload.data?.history_id || Date.now(),
      title: payload.notification?.title || payload.data?.title || "New Notification",
      body: payload.notification?.body || payload.data?.body || "",
      icon: payload.notification?.icon || "/logo192.png",
      data: payload.data || {},
      deepLinkScreen: payload.data?.deep_link_screen || null,
      deepLink: payload.data?.deep_link || null,
    };

    if (onMessageCallback) {
      onMessageCallback(notification);
    }
  });
};

/**
 * Track notification click for analytics
 * @param {string|number} historyId - Notification history ID
 */
export const trackNotificationClick = async historyId => {
  if (!historyId) return;

  try {
    await axios.post(`/v1/notifications/clicked/${historyId}`);
  } catch (error) {
    // Silent fail
  }
};
